// $(document).ready(function() {
//   // Add the 'box-sh' class to the first .color-swatch div on page load
//   $('.color-swatch').not('.size_swatch__size .color-swatch').first().addClass('box-sh');

//   // Event handler for click on .color-swatch
//   $('.color-swatch').on('click', function() {
//     // Check if the clicked .color-swatch is NOT inside a parent with class .size_swatch__size
//     if (!$(this).closest('.size_swatch__size').length) {
//       // Remove the 'box-sh' class from all .color-swatch elements
//       $('.color-swatch').removeClass('box-sh');

//       // Add the 'box-sh' class to the clicked .color-swatch
//       $(this).addClass('box-sh');
//     }
//   });
// });


// $(document).ready(function() {
//   $('.color-swatch').on('click', function() {   
//     $('.color-swatch').removeClass('box-sh');
//     $(this).closest('.color-swatch').addClass('box-sh');
//   });
// });

// $(document).ready(function() {
//   $('.color-swatch').on('click', function() {
//     // Check if the clicked .color-swatch is NOT inside a parent with class .size_swatch__size
//     if (!$(this).closest('.size_swatch__size').length) {
//       // Remove the 'box-sh' class from all .color-swatch elements
//       $('.color-swatch').removeClass('box-sh');

//       // Add the 'box-sh' class to the clicked .color-swatch
//       $(this).addClass('box-sh');
//     }
//   });
// });




$(document).ready(function () {
	setTimeout(function () {
		if(document.querySelector(".quantity-breaks-container")) {
			$(".quantity-breaks-container input[checked]")
			.next("label")
			.addClass("active_label");

			$(".quantity-breaks-container input").click(function () {
				$("label").removeClass("active_label");

				$(this).next("label").addClass("active_label");
			});
		}
		if(document.querySelector("span.size_btn_guide")) {
			$("span.size_btn_guide").click(function () {
				$(".product_size_quide").addClass("active");
				$("body").addClass("size_popup_active");
			});
	
			$(" span.cross_size_guide").click(function () {
				$(" .product_size_quide").removeClass("active");
				$("body").removeClass("size_popup_active");
			});
		}
	}, 500);
});
$(document).ready(function () {
	if(document.querySelector('.center-slider')) {
		$(".center-slider").slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			arrows: true,
			dots: true,
			speed: 300,
			centerPadding: "20px",
			infinite: true,
			autoplaySpeed: 5000,
			autoplay: false,
			responsive: [
				{
					breakpoint: 765,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
			],
		});
	}
});


(() => {
	if(window.location.pathname.includes('/products/')) {
		let color_label = document.querySelector(
			"label.option-color span"
		);
		let size_label = document.querySelector(
			"div.size_swatches .custom-size-label"
		);
		let color_swatche_inputs = document.querySelectorAll(
			"variant-selects .product-form__input--swatches .color-swatches-container input"
		);

		let size_swatche_inputs = document.querySelectorAll(
			"variant-selects .product-form__input--size_swatches .size-swatches-container input"
		);
	
		function extractSize(text) {
			const match = text.match(/-\s*(.*?)(?= \()/);
			if (match) {
				return match[1].trim();
			}
			return null;
		}
		size_swatche_inputs.forEach((input) => {
			input.addEventListener("change", (e) => {
				size_label.innerHTML = "Size: " + extractSize(input.value);
			});
		});

		color_swatche_inputs.forEach((input) => {
			input.addEventListener("change", (e) => {
				color_label.innerHTML = "Color: " + input.value
			});
		});
	}
})();


(() => {
	function injectCSSIntoShadowRoot() {
		const chatWidget = document.querySelector('chat-widget');
		
		if (chatWidget && chatWidget.shadowRoot) {
			const shadowRoot = chatWidget.shadowRoot;
			
			// Create a style element
			const style = document.createElement('style');
			style.textContent = `
			.fixed {
				z-index: 23456 !important;
			}
			`;
			
			// Append the style to shadow root
			shadowRoot.appendChild(style);
		} 
	}

	function waitForChatWidgetAndInjectCSS() {
		// Try immediate injection first
		if (injectCSSIntoShadowRoot()) {
			return;
		}
		
		console.log('Chat widget not found, waiting for it...');
		
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.nodeType === Node.ELEMENT_NODE) {
				if (node.matches && node.matches('chat-widget')) {
					setTimeout(() => {
					if (injectCSSIntoShadowRoot()) {
						observer.disconnect();
					}
					}, 100);
				}
				}
			});
			});
		});
		
		observer.observe(document.body, { childList: true, subtree: true });
		
		// Cleanup after 30 seconds
		setTimeout(() => observer.disconnect(), 30000);
		}

	waitForChatWidgetAndInjectCSS();
})();